document.addEventListener('DOMContentLoaded', function() {
  // Initialize all Video Carousels on the page
  const carousels = document.querySelectorAll('.video-carousel-splide');

  carousels.forEach(function(carousel) {
    initializeVideoCarousel(carousel);
  });

  // Reinitialize carousels when sections are reloaded in theme editor
  document.addEventListener('shopify:section:load', function(event) {
    const carouselsInSection = event.target.querySelectorAll('.video-carousel-splide');
    carouselsInSection.forEach(function(carousel) {
      initializeVideoCarousel(carousel);
    });
  });
});

function initializeVideoCarousel(carouselElement) {
  // Get section settings from the element's section
  const section = carouselElement.closest('.video-carousel');
  if (!section) return;

  // Extract settings from JSON script
  const sectionId = carouselElement.id.replace('video-carousel-', '');
  const settingsScript = document.querySelector(`#video-carousel-settings-${sectionId}`);

  // Default settings
  let settings = {
    videosPerPage: 3,
    videosPerPageMobile: 1,
    showPagination: true,
    hideNavigationDesktop: false,
    autoplay: false,
    autoplaySpeed: 5000,
    videoAutoplay: false,
    videoMuted: true
  };

  // Override with section settings if available
  if (settingsScript) {
    try {
      const sectionSettings = JSON.parse(settingsScript.textContent);
      settings = { ...settings, ...sectionSettings };
    } catch (e) {
      console.warn('Failed to parse video carousel settings:', e);
    }
  }

  // Determine responsive breakpoints
  const isMobile = window.innerWidth <= 767;
  const perPage = isMobile ? settings.videosPerPageMobile : settings.videosPerPage;

  // Determine if pagination should be shown (hide on desktop if setting is enabled)
  const showPaginationOnThisDevice = isMobile ? settings.showPagination : (settings.showPagination && !settings.hideNavigationDesktop);

  // Splide configuration with Video extension
  const splideConfig = {
    type: 'slide',  // Desktop default: no infinite loop
    perPage: 1,  // Always show 1 slide in center
    perMove: 1,
    gap: '25px',  // Desktop gap
    padding: 0,  // Desktop: no padding
    breakpoints: {
      767: {
        type: 'loop',  // Mobile: enable infinite loop
        perPage: 1,  // 1 slide on mobile
        gap: '15px',
        padding: 'calc(50% - 92px)'  // Center 184px slide on mobile
      }
    },
    arrows: false,
    pagination: showPaginationOnThisDevice,
    autoplay: settings.autoplay,
    interval: settings.autoplaySpeed,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: false,
    rewind: false,
    focus: 0,
    trimSpace: false,
    classes: {
      pagination: 'splide__pagination',
      page: 'splide__pagination__page'
    },
    // Video extension options
    video: {
      autoplay: settings.videoAutoplay,
      mute: settings.videoMuted,
      hideControls: false,
      loop: false,
      volume: 0.2
    }
  };

  // Initialize Splide with Video extension
  try {
    const splide = new Splide(carouselElement, splideConfig);

    // Check if Video extension is available
    if (typeof splide.mount === 'function' && window.splide && window.splide.Extensions && window.splide.Extensions.Video) {
      // Mount with Video extension
      splide.mount(window.splide.Extensions.Video);
    } else {
      // Mount without Video extension as fallback
      console.warn('Splide Video extension not available, mounting carousel without video features');
      splide.mount();
    }

    // Handle video-specific events
    splide.on('active', function(slide) {
      // Pause other videos when a new slide becomes active
      const videos = carouselElement.querySelectorAll('video');
      videos.forEach(function(video, index) {
        if (index !== slide.index && !video.paused) {
          video.pause();
        }
      });
    });

    // Handle video autoplay based on visibility
    if (settings.videoAutoplay) {
      splide.on('active', function(slide) {
        const activeSlide = slide.slide;
        const video = activeSlide.querySelector('video');
        if (video && video.paused) {
          // Ensure video is muted for autoplay
          video.muted = true;
          video.play().catch(function(error) {
            console.warn('Video autoplay failed:', error);
          });
        }
      });
    }

    // Handle responsive changes
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const newIsMobile = window.innerWidth <= 767;
        const newPerPage = newIsMobile ? settings.videosPerPageMobile : settings.videosPerPage;

        // Update configuration if screen size category changed
        if (newIsMobile !== isMobile) {
          splide.options = {
            perPage: newPerPage
          };
          splide.refresh();
        }
      }, 250);
    });

    // Store the splide instance for potential cleanup
    carouselElement.splideInstance = splide;

    // Initialize video loading states
    initializeVideoLoadingStates(carouselElement);

  } catch (error) {
    console.error('Failed to initialize Video Carousel:', error);

    // Fallback: show all slides in a grid if Splide fails
    const track = carouselElement.querySelector('.splide__track');
    const list = carouselElement.querySelector('.splide__list');

    if (track && list) {
      track.style.overflow = 'visible';
      list.style.display = 'grid';
      list.style.gridTemplateColumns = `repeat(auto-fit, minmax(300px, 1fr))`;
      list.style.gap = '2rem';
      list.style.transform = 'none';

      // Hide navigation elements
      const pagination = carouselElement.querySelector('.splide__pagination');
      if (pagination) pagination.style.display = 'none';
    }
  }
}

function initializeVideoLoadingStates(carouselElement) {
  const videos = carouselElement.querySelectorAll('video');

  videos.forEach(function(video) {
    const videoWrapper = video.closest('.video-wrapper');
    const playButton = videoWrapper ? videoWrapper.querySelector('.video-play-button') : null;
    const playButtonOverlay = videoWrapper ? videoWrapper.querySelector('.video-play-button-overlay') : null;

    // Add click handler for custom play button
    if (playButton) {
      playButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Play button clicked for video:', video);

        if (video.paused) {
          // Show loading spinner
          videoWrapper.setAttribute('data-video-loading', 'true');

          video.play().then(function() {
            console.log('Video started playing successfully');
            // Remove loading spinner when video starts playing
            videoWrapper.removeAttribute('data-video-loading');
          }).catch(function(error) {
            console.error('Error playing video:', error);
            // Remove loading spinner on error
            videoWrapper.removeAttribute('data-video-loading');
          });
        } else {
          video.pause();
          console.log('Video paused');
        }
      });
    }

    // Add click handler for play button overlay as backup
    if (playButtonOverlay) {
      playButtonOverlay.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Play button overlay clicked for video:', video);

        if (video.paused) {
          // Show loading spinner
          videoWrapper.setAttribute('data-video-loading', 'true');

          video.play().then(function() {
            console.log('Video started playing successfully');
            // Remove loading spinner when video starts playing
            videoWrapper.removeAttribute('data-video-loading');
          }).catch(function(error) {
            console.error('Error playing video:', error);
            // Remove loading spinner on error
            videoWrapper.removeAttribute('data-video-loading');
          });
        } else {
          video.pause();
          console.log('Video paused');
        }
      });
    }

    // Add loading state and ensure proper video attributes
    video.setAttribute('data-loading', 'true');

    // Ensure video has proper attributes for interaction
    if (!video.hasAttribute('controls')) {
      video.setAttribute('controls', 'true');
    }

    // Set up video for better playback compatibility
    video.setAttribute('playsinline', 'true');
    video.setAttribute('webkit-playsinline', 'true');

    console.log('Video initialized:', video, 'Has sources:', video.querySelectorAll('source').length);

    // Remove loading state when video can play
    video.addEventListener('loadeddata', function() {
      video.removeAttribute('data-loading');
    });

    // Handle load errors
    video.addEventListener('error', function() {
      video.removeAttribute('data-loading');
      console.warn('Video failed to load:', video.src);
    });

    // Handle video play event - hide cover image
    video.addEventListener('play', function() {
      if (videoWrapper) {
        videoWrapper.classList.add('playing');
        // Remove loading spinner when video actually starts playing
        videoWrapper.removeAttribute('data-video-loading');
      }
    });

    // Handle video pause event - show cover image
    video.addEventListener('pause', function() {
      if (videoWrapper) {
        videoWrapper.classList.remove('playing');
      }
    });

    // Handle video ended event - show cover image
    video.addEventListener('ended', function() {
      if (videoWrapper) {
        videoWrapper.classList.remove('playing');
      }
      video.currentTime = 0;
    });

    // Handle video seeking/waiting - manage cover visibility
    video.addEventListener('waiting', function() {
      if (videoWrapper) {
        videoWrapper.classList.remove('playing');
      }
    });

    video.addEventListener('playing', function() {
      if (videoWrapper) {
        videoWrapper.classList.add('playing');
      }
    });
  });
}

// Cleanup function for theme editor
document.addEventListener('shopify:section:unload', function(event) {
  const carouselsInSection = event.target.querySelectorAll('.video-carousel-splide');
  carouselsInSection.forEach(function(carousel) {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
      carousel.splideInstance = null;
    }

    // Pause all videos in the section
    const videos = carousel.querySelectorAll('video');
    videos.forEach(function(video) {
      if (!video.paused) {
        video.pause();
      }
    });
  });
});

// Handle intersection observer for video autoplay (when videos come into view)
if ('IntersectionObserver' in window) {
  const videoObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      const video = entry.target;
      const carousel = video.closest('.video-carousel-splide');
      if (!carousel) return;

      const sectionId = carousel.id.replace('video-carousel-', '');
      const settingsScript = document.querySelector(`#video-carousel-settings-${sectionId}`);
      let videoAutoplay = false;

      if (settingsScript) {
        try {
          const settings = JSON.parse(settingsScript.textContent);
          videoAutoplay = settings.videoAutoplay;
        } catch (e) {
          // Use default
        }
      }

      if (entry.isIntersecting && videoAutoplay) {
        // Video is in view and autoplay is enabled
        video.muted = true;
        video.play().catch(function(error) {
          console.warn('Video autoplay failed:', error);
        });
      } else if (!entry.isIntersecting) {
        // Video is out of view, pause it
        if (!video.paused) {
          video.pause();
        }
      }
    });
  }, {
    threshold: 0.5 // Trigger when 50% of video is visible
  });

  // Observe all videos in carousels
  document.addEventListener('DOMContentLoaded', function() {
    const videos = document.querySelectorAll('.video-carousel-splide video');
    videos.forEach(function(video) {
      videoObserver.observe(video);
    });
  });

  // Observe new videos when sections are loaded
  document.addEventListener('shopify:section:load', function(event) {
    const videos = event.target.querySelectorAll('.video-carousel-splide video');
    videos.forEach(function(video) {
      videoObserver.observe(video);
    });
  });
}

// Helper function to get section settings
function getSectionSettings(sectionElement) {
  const settingsElement = sectionElement.querySelector('[data-section-settings]');
  if (settingsElement) {
    try {
      return JSON.parse(settingsElement.getAttribute('data-section-settings'));
    } catch (e) {
      console.warn('Failed to parse section settings:', e);
    }
  }
  return {};
}